import React from 'react';
const UserNotFound = () => {

  return (
    <div>
      <main>
        <h1 >Sorry!,
      seems like you dont have access to Magnus Dashboard <em>. . . Please reach out to Blr-QA-Tools(@alexa-tools-titans) for the access.</em>
        </h1>
      </main>
      <aside><img src="https://s3-us-west-2.amazonaws.com/s.cdpn.io/4424790/Mirror.png" alt="404 Image" />
      </aside>
    </div>
  )
};

export default UserNotFound;